import React, { createContext, useContext, useEffect, useState } from "react";
import { getSession, login as apiLogin, register as apiRegister, logout as apiLogout } from "./api.js";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);    // { id, email, sensitivity, plan, ... } or null
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    getSession()
      .then(({ user }) => mounted && setUser(user || null))
      .catch(() => mounted && setUser(null))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  const login = async (creds) => {
    const { user } = await apiLogin(creds);
    setUser(user || null);
    return user;
  };

  const register = async (payload) => {
    const { user } = await apiRegister(payload);
    setUser(user || null);
    return user;
  };

  const logout = async () => {
    await apiLogout();
    setUser(null);
  };

  const value = { user, setUser, loading, login, register, logout };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
